// extracted by mini-css-extract-plugin
export default {"innerWrapper":"YD-z","tooltipWrapper":"ZD-z","icon":"_D-z","tooltip":"aE-z","content":"bE-z"};